import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './StickyContextBar.css';

interface StickyContextBarProps {
  itemId: string;
  status: string;
  statusColor?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';
  backPath?: string;
  actions?: React.ReactNode;
}

const StickyContextBar: React.FC<StickyContextBarProps> = ({
  itemId,
  status,
  statusColor = 'neutral',
  backPath,
  actions,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  const formatStatus = (raw: string): string => {
    return raw
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div className="sticky-context-bar">
      <div className="sticky-context-bar__left">
        <button
          type="button"
          className="sticky-context-bar__back"
          onClick={handleBack}
          aria-label="Go back"
        >
          <span className="sticky-context-bar__back-arrow"><ArrowLeft size={14} /></span>
          Back
        </button>

        <span className="sticky-context-bar__id">{itemId}</span>

        <span className="sticky-context-bar__separator" aria-hidden="true" />

        <span
          className={`sticky-context-bar__status sticky-context-bar__status--${statusColor}`}
        >
          {formatStatus(status)}
        </span>
      </div>

      {actions && (
        <div className="sticky-context-bar__actions">
          {actions}
        </div>
      )}
    </div>
  );
};

export default StickyContextBar;
